module.exports = __webpack_public_path__ + "static/media/polysarcus_denticauda_005_APA.8c3d5703.mp3";